import { FC } from 'react';
import { Flex, Heading, Link, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

export type NoSubscriptionPageProps = {
  service?: string;
};

export const NoSubscriptionPage: FC<NoSubscriptionPageProps> = ({
  service,
}) => {
  return (
    <Flex w="100%" minH="70vh" direction="row">
      <Flex
        flex="1"
        h="100%"
        w="100%"
        direction="column"
        justifyContent="center"
        alignItems="center"
        px="40px"
        py="24px">
        <Flex direction="column" justifyContent="flex-start">
          {service && (
            <Heading as="h1" size="3xl" mb="24px">
              {service}
            </Heading>
          )}
          <Heading as="p" size="lg" mb={4}>
            You currently are not subscribed to this service.
          </Heading>
          <Text as="p" size="xl">
            You can contact Yapamar to upgrade your account.
          </Text>
          <Text as="p" size="xl">
            Use the menu to select a different service{' '}
            <Link as={RouterLink} to="/">
              or return to the dashboard.
            </Link>
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
